module.exports = __webpack_public_path__ + "static/media/VA.6970ef5f.png";